import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import services from '../services';
import withResponseHandling from './withResponseHandling';
import withMessage from './withMessage';
import { acCarteirasChanged } from '../store/actions';

const PAGE_SIZE = 25;

const withAvaliacoesQuestoes = Component => {
  function WrapComponent(props) {
    const entidadeId = useSelector(state => state.entidade.current.default_entidade_id);
    const storeDispatch = useDispatch();

    const [questoes, setQuestoes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: PAGE_SIZE
    });

    function updateStore(pData) {
      storeDispatch(acCarteirasChanged(pData));
    }

    const readQuestoes = useCallback(
      (pParams = {}, pCallback) => {
        if (!questoes.length) {
          setIsLoading(true);
        } else {
          setIsRefetching(true);
        }

        const xParams = {
          size: PAGE_SIZE,
          page: 1,
          sort: 'avaliacao_questao_id desc',
          ...pParams
        };

        services.questoes.list(
          xParams,
          rRes => {
            const xQuestoes = Object.values(rRes.data || {});

            setQuestoes(xQuestoes);
            setRowCount(rRes.pages?.total_items || xQuestoes.length);
            pCallback && pCallback(xQuestoes);
          },
          rErr => {
            props.responseErrorHandling(rErr);
          },
          () => {
            setIsLoading(false);
            setIsRefetching(false);
          }
        );
      },
      [questoes.length, props]
    );

    const deleteQuestoes = (pQuestaoId, onFinish) => {
      services.questoes.remove(
        { avaliacao_questao_id: pQuestaoId },
        () => {
          props.onMessageSuccess('Questão excluída com sucesso');
          readQuestoes({}, updateStore);
          setRowSelection({});
        },
        rErr => {
          props.responseErrorHandling(rErr);
        },
        () => {
          onFinish && onFinish();
        }
      );
    };

    const bulkDeleteQuestoes = pRows => {
      const xQuestoesId = pRows.map(xRow => xRow.original.avaliacao_questao_id).filter(Boolean);

      xQuestoesId.forEach(xId => {
        deleteQuestoes(xId);
      });
    };

    useEffect(() => {
      const xPage = pagination.pageIndex + 1;

      readQuestoes({
        page: xPage,
        size: pagination.pageSize
      });
    }, [readQuestoes, pagination.pageIndex, pagination.pageSize, entidadeId]);

    const xProps = {
      questoes,
      isLoading,
      isRefetching,
      rowCount,
      rowSelection,
      pagination,
      setPagination,
      setRowSelection,
      readQuestoes,
      deleteQuestoes,
      bulkDeleteQuestoes
    };

    return <Component {...xProps} />;
  }

  return withMessage(withResponseHandling(WrapComponent));
};

export default withAvaliacoesQuestoes;
